import { LegacyCRMIframeID, ReactToLegacyCrmPostMessageAction } from './Constants'
import { IframeMessageOptions } from './types'

/**
 * -----------------------------------------------------------------------------------
 * To do: This is a standard postMessage call to open any panel, need to customise the
 * message action to be panel driven by accepting it as parameter
 * eg. panel to open enews, email, letter, etc
 * -----------------------------------------------------------------------------------
 *
 * Sends a postMessage to the legacy CRM iframe once it has loaded.
 *
 * Props:
 * @param action (string): Determines the PostMessage action to differentiate event types
 * @param iframeLoaded (boolean): Determines whether the iframe is ready to receive messages.
 * @param pageName (string): Page name to send to the iframe.
 * @param legacyLink (optional object): Optional legacy panel parameters to pass along.
 * @param modalLink (optional object): Optional legacy modal parameters as whole string to pass along.
 * @param deleteRecLink (optional object): Optional legacy deleteRec modal parameters as whole string to pass along.
 * @param hasTranslucentBg (optional boolean): Optional flag to apply a translucent background on the iframe side.
 *
 * This function:
 * 1. Checks if the iframe has loaded.
 * 2. Constructs a message payload with the given options.
 * 3. Locates the iframe by ID (`LegacyCRMIframeID`).
 * 4. Sends the message using `postMessage` to the iframe's content window.
 *
 * Note: This function is side-effect only and does not return anything.
 */
export const LegacyCRMIframeOpenPanel = ({
  action = ReactToLegacyCrmPostMessageAction.ReactToIframeMessageOpenPanel,
  iframeLoaded,
  pageName,
  legacyLink,
  modalLink,
  deleteRecLink,
  hasTranslucentBg,
  legacyCRMUrl,
}: IframeMessageOptions): void => {
  if (!iframeLoaded) return

  const message = {
    action,
    data: {
      pageName,
      ...(hasTranslucentBg && { hasTranslucentBg }),
      ...(legacyLink && { legacyLink }),
      ...(modalLink && { modalLink }),
      ...(deleteRecLink && { deleteRecLink }),
    },
  }

  const iframe = document.getElementById(LegacyCRMIframeID) as HTMLIFrameElement | null
  if (iframe && iframe.contentWindow) {
    iframe.contentWindow.postMessage(message, legacyCRMUrl)
  }
}
